import { Box, Spinner } from '@ouster/webviz-react-components';

import { RiListSettingsLine } from 'react-icons/ri';

import DashboardCard from './DashboardCard';
import InfoItem from './InfoItem';
import { InfoItemType } from './types';
import { formatDate } from './utils';
import { useStoreState } from '../../reducers';

export default function RecordingLookUpOverview() {
  const { recordingLookupResult, isLoadingRecordingLookup } = useStoreState(
    (storeState) => storeState.adminDashboard
  );

  const cardProps = {
    icon: <RiListSettingsLine size={20} />,
    title: 'Overview',
  };

  if (isLoadingRecordingLookup) {
    return (
      <DashboardCard {...cardProps}>
        <Box display="flex" alignItems="center" justifyContent="center" my={8}>
          <Spinner />
        </Box>
      </DashboardCard>
    );
  }

  if (!recordingLookupResult) return null;

  const overviewItems: InfoItemType[] = [
    { label: 'Recording ID', value: recordingLookupResult.id },
    {
      label: 'Organization',
      value: recordingLookupResult.organization_name ?? '',
    },
    {
      label: 'Uploaded By',
      value: recordingLookupResult.uploaded_by ?? '',
    },
    {
      label: 'Processed At',
      value: recordingLookupResult.processed_at
        ? formatDate(recordingLookupResult.processed_at)
        : '',
    },
    {
      label: 'Is Public',
      value: recordingLookupResult.publication_uuid ? 'Public' : 'Private',
      color: 'info',
    },
    { label: 'Category', value: recordingLookupResult.data_category ?? '' },
    { label: 'Tags', value: recordingLookupResult.tags.join(', ') ?? '' },
    {
      label: 'Visualization Status',
      value: recordingLookupResult.visualization_status ?? '',
      color:
        recordingLookupResult.visualization_status === 'VIEWABLE'
          ? 'success'
          : 'warning',
    },
  ];

  return (
    <DashboardCard {...cardProps} data-testid="recording-lookup-overview-card">
      <Box
        display="grid"
        gridTemplateColumns="repeat(3, 1fr)"
        columnGap={4}
        rowGap={6}
      >
        {overviewItems.map((item) => (
          <InfoItem
            key={item.label}
            label={item.label}
            value={item.value}
            color={item.color}
            data-testid={`recording-lookup-overview-item-${item.label
              .toLowerCase()
              .replace(/\s/g, '-')}`}
          />
        ))}
      </Box>
    </DashboardCard>
  );
}
